
(function actoinsModuleDefinition() {

    'use strict';

    angular.module('Actions', ['Config','AuthExtend', 'Entities'])
        .config([
            'configProvider',function (config) {
        }]);

})();